const OutComesSection = () => {
    const outcomesContent = [
        {
            id: "01",
            title: "Better ovulation consistency",
            desc: "Track and support regular ovulation cycles for improved fertility outcomes.",
            img: "/Programs/OutComes/ovulationImage.svg",
        },
        {
            id: "02",
            title: "Higher chances of conception",
            desc: "Optimize your body’s readiness to increase the likelihood of natural conception.",
            img: "/Programs/OutComes/ConceptionImage.svg",
        },
        {
            id: "03",
            title: "Hormonal balance",
            desc: "Stabilize key hormones to support a healthier reproductive system.",
            img: "/Programs/OutComes/gynacImage.svg",
        },
        {
            id: "04",
            title: "More confidence & clarity",
            desc: "Understand your body better and make informed decisions with expert guidance.",
            img: "/Programs/OutComes/confidenceImage.svg",
        },
    ];

    return (
        <div className="mx-auto">
            <div className="mx-2 my-8 md:mx-8 md:my-12 lg:mx-16 lg:my-16">
                <div className="flex flex-col gap-4 md:gap-8 items-center mx-4 md:mx-1 lg:mx-2">
                    <h2 className="ava-heading-lg">Outcomes</h2>
                    {/* Grid Container */}
                    <div className="
                        grid grid-cols-1 
                        md:grid-cols-2 
                        gap-x-6 sm:gap-x-6 lg:gap-x-16 
                        gap-y-4 sm:gap-y-6 lg:gap-y-8
                            ">
                        {outcomesContent.map((item) => (
                            <CardWithImage item={item} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
export const CardWithImage = ({ item,
    imgHeight = "h-55",
    imgWidth = "md:w-[50%]",
    cardHeight = "h-55",
    cardWidth = "max-w-[435px]",
    titleColor = "text-[var(--primary-color)]",
    titleSize = "ava-text-subheading",
    titleWeight = "font-[500]",
}) => {
    return (
        <div
            key={item.id}
            className={` flex overflow-hidden ava-radius-md w-full ${cardWidth} ${cardHeight} ava-card-bg ava-card-mukta
    flex-col min-[425px]:flex-row
`}
        >
            {/* Left: Image (40% width) */}
            <div
                className={`w-full ${imgWidth} ${imgHeight}`}
            >
                <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover rounded-xl"
                />
            </div>
            <div
                className={`relative w-full md:w-[50%] ava-card-bg p-4 flex flex-col 
  ${item?.desc ? "justify-start" : "justify-center items-center text-center"}
`}
            >
                {/* Content (Z-index ensure text is above number) */}
                <div className="relative z-10">
                    <h3
                        className={`${titleSize} ${titleWeight} mb-1`}
                    >
                        {item.title}
                    </h3>
                    <p className="ava-text-body max-w-[240px]">
                        {item?.desc}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default OutComesSection